import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {FilterModel} from '@/libs/Api';
import {FiltersDataService} from '@/libs/filters/filters-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const filtersStore = registerCrudStore<FilterModel, FilterModel>(BusinessModule.Filter, new FiltersDataService());
